import { store } from '../lib/configureStore';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const waitForSyncReady = async () => {
  const isSyncReady = () => {
    const state = store.getState();
    return state.workflow.changesQueue.length === 0 && !state.workflow.isSyncing && !state.workflow.isUpdating;
  };

  await delay(0);
  while (!isSyncReady()) {
    await delay(100);
  }
};

export default waitForSyncReady;
